const FOOTER_LINKS = [
  { label: "About", href: "#about" },
  { label: "The Fleet", href: "#fleet" },
  { label: "Training Hub", href: "#training" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/8 bg-[#040B16]" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Tide Water Studios" className="h-12 w-12 object-cover logo-medallion" />
              <span className="font-display text-2xl text-[#F8FAFC]">
                Tide Water <span className="text-[#94A3B8]">Studios</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm font-body text-sm leading-relaxed text-[#94A3B8]">
              Adaptive software &amp; technical consulting from Whitehorse,
              Yukon.
            </p>
            <a
              href="https://www.tidewaterstudios.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono-2 mt-6 inline-block text-[0.72rem] uppercase tracking-[0.2em] text-[#94A3B8] transition-colors hover:text-[#F8FAFC]"
              data-testid="footer-url"
            >
              www.tidewaterstudios.ca
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="overline mb-6">/ Explore</p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="font-body text-[#94A3B8] transition-colors hover:text-[#F8FAFC]" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-6">/ Studio</p>
            <p className="font-body text-sm leading-relaxed text-[#94A3B8]">
              Whitehorse<br />Yukon Territory<br />Canada
            </p>
          </div>
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
          <p className="font-mono-2 text-[0.68rem] uppercase tracking-[0.16em] text-[#475569]" data-testid="footer-copyright">
            © 2026 Tide Water Studios Inc.
          </p>
          <p className="font-mono-2 text-[0.68rem] uppercase tracking-[0.16em] text-[#475569]">
            Powered by Tide Water Studios Inc.
          </p>
        </div>
        <a
          href="/the-helm"
          aria-label="The Helm"
          title="The Helm"
          className="mt-6 flex justify-center text-[#334155] transition-colors hover:text-[#94A3B8]"
          data-testid="footer-helm-link"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="5" r="3" />
            <line x1="12" y1="22" x2="12" y2="8" />
            <path d="M5 12H2a10 10 0 0 0 20 0h-3" />
          </svg>
        </a>
      </div>
    </footer>
  );
};
